/* DermaPharma smooth marquee — replaces Flickity slide-snap. Original behavior backed up. */
!function () {
  "use strict";
  const SLIDER = "[data-slider-logos]";
  const SLIDE  = "[data-slide]";
  const MARQUEE_CLASS = "dp-logos-marquee";

  if (customElements.get("logos-component")) return;

  customElements.define("logos-component", class extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector(SLIDER);
    }
    connectedCallback() {
      if (!this.slider) return;

      // Clone the slide nodes once so the loop is seamless (translateX -50% returns to start visually)
      const slides = Array.from(this.slider.querySelectorAll(SLIDE));
      if (slides.length === 0) return;
      slides.forEach(node => {
        const clone = node.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        clone.removeAttribute("data-slide");
        this.slider.appendChild(clone);
      });

      // Mark for CSS marquee styling
      this.slider.classList.add(MARQUEE_CLASS);
      // Prevent Flickity from later attaching (defensive — Flickity inits on its own elsewhere only if .flickity-enabled is missing)
      this.slider.setAttribute("data-marquee-initialized", "true");
    }
  });
}();
